(function () {
  // Параметры трекинга, которые навешивает приложение рекомендаций
  var DIRTY_PARAMS = ['pr_prod_strat', 'pr_rec_id', 'pr_rec_pid', 'pr_ref_pid', 'pr_seq'];

  function cleanUrl(rawHref) {
    try {
      var url = new URL(rawHref, window.location.origin);
      DIRTY_PARAMS.forEach(function (p) { url.searchParams.delete(p); });
      // Если параметров не осталось — отдаём чистый путь без "?"
      var qs = url.searchParams.toString();
      return url.origin + url.pathname + (qs ? '?' + qs : '');
    } catch (e) {
      return rawHref;
    }
  }

  function cleanLinksIn(root) {
    if (!root) return;
    var links = root.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (a) {
      var cleaned = cleanUrl(a.getAttribute('href'));
      if (cleaned !== a.getAttribute('href')) {
        a.setAttribute('href', cleaned);
      }
    });
  }

  function init() {
    var blocks = document.querySelectorAll('product-recommendations');
    blocks.forEach(function (block) {
      // 1) Чистим то, что уже отрендерено
      cleanLinksIn(block);

      // 2) Следим за изменениями (приложение подгружает/перезаписывает ссылки асинхронно)
      var observer = new MutationObserver(function () {
        cleanLinksIn(block);
      });
      observer.observe(block, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

      // 3) Подстраховка на клик — чистим href прямо перед переходом
      block.addEventListener('mousedown', function (e) {
        var a = e.target.closest && e.target.closest('a[href*="/products/"]');
        if (a) a.setAttribute('href', cleanUrl(a.getAttribute('href')));
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();